module.exports = __webpack_public_path__ + "img/fintech-thumb.f50b489f.jpg";